import { c as _c } from "react/compiler-runtime";
import { HStack, Heading, Icon, VStack } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { ViewableTracker } from '@src/components/sco/ViewableTracker';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ContentTrackStep } from '@src/graphql-types';
import { LuBookOpen } from 'react-icons/lu';
type StepBodyProps = {
  body: string;
  color?: string;
  contentTrackStep?: ContentTrackStep;
  title?: string;
};
export const ContentStep = props => {
  const $ = _c(13);
  const trackContext = useContentTrackContext();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = trackContext.contentTrackEnrollment?.contentTrackEnrollmentId;
  const t1 = props.contentTrackStep.id;
  const t2 = props.contentTrackStep.__typename;
  let t3;
  if ($[0] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 6]);
    $[0] = getBreakpointValue;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HStack align="center"><Icon asChild={true}><LuBookOpen /></Icon><Heading size="xs">Lesson</Heading></HStack>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== props.body) {
    t5 = <MarkdownRenderer preset="edu">{props.body}</MarkdownRenderer>;
    $[3] = props.body;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <VStack align="flex-start" gap={t3} width="full">{t4}{t5}</VStack>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== props.contentTrackStep.__typename || $[9] !== props.contentTrackStep.id || $[10] !== t0 || $[11] !== t6) {
    t7 = <ViewableTracker parentId={t0} parentType="ContentTrackEnrollment" trackScrolling={true} viewableContext="content" viewableId={t1} viewableType={t2}>{t6}</ViewableTracker>;
    $[8] = props.contentTrackStep.__typename;
    $[9] = props.contentTrackStep.id;
    $[10] = t0;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};